// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getMediaData, MediaDataCollection } from "@bg/App/Services/MediaDataService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{}, MediaDataCollection>;

export const DispatchBeginLoadMediaData: HandlerType = (props: any) => {
    props.dispatch({
        type: "xMediaData/BeginLoadMediaData",
    });
};

export const RequestDataFromApi: HandlerType = async (props: any) => {
    const response = await getMediaData();
    if (!response.success) {
        props.dispatch({
            type: "xMediaData/CompleteLoadMediaData",
            mediaData: null,
        });
        return;
    }
    props.apiResult = response;
};

export const DispatchCompleteLoadMediaData: HandlerType = (props: any) => {
    props.dispatch({
        type: "xMediaData/CompleteLoadMediaData",
        mediaData: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadMediaData, RequestDataFromApi, DispatchCompleteLoadMediaData];

const loadMediaData = createHandlerChainRunner(chain, "loadMediaData");
export default loadMediaData;
